/**
 * The purchase process's transitions and states that the order page reads an
 * order's history by, named from the process (transactionProcessPurchase.js)
 * and kept in one place for the page, its panels and its data.
 */
import {
  graph,
  transitions as T,
  states as S,
} from '../../transactions/transactionProcessPurchase';

/** The order was paid: a purchase's payment, or an accepted offer's. */
export const PAID_TRANSITIONS = [T.CONFIRM_PAYMENT, T.CONFIRM_OFFER_PAYMENT];

/** The seller (or TradMarket, at the carrier's first scan) marked it shipped. */
export const SHIPPED_TRANSITIONS = [T.MARK_SHIPPED, T.OPERATOR_MARK_SHIPPED];

/**
 * Transitions that land an order in :state/received: when the buyer got it,
 * when the carrier didn't say. The server's list (returns-record.js);
 * orderRules.parity.test.js keeps the two equal.
 */
export const RECEIVED_TRANSITIONS = [
  T.MARK_RECEIVED,
  T.OPERATOR_MARK_RECEIVED,
  T.AUTO_MARK_RECEIVED,
  T.AUTO_COMPLETE_NO_DISPUTE,
  T.CUSTOMER_CONFIRM_PICKUP,
  T.CUSTOMER_CONFIRM_ARRIVED,
  T.CUSTOMER_CLOSE_DISPUTE,
  T.MARK_RECEIVED_FROM_DISPUTED,
];

/**
 * Transitions that land an order in :state/completed, from the process graph: the first
 * of them in an order's history is when it completed (later ones bring it back there,
 * after a return or a label bought late).
 */
export const COMPLETED_TRANSITIONS = Object.values(graph.states).flatMap(state =>
  Object.entries(state.on || {})
    .filter(([, to]) => to === S.COMPLETED)
    .map(([transition]) => transition)
);

/** A return is under way: requested, on its way back, or with TradMarket after a rejection. */
export const RETURN_STATES = [S.RETURN_INITIATED, S.RETURN_SHIPPED, S.RETURN_REJECTED];

/**
 * States the process leaves on its own as soon as an order enters them
 * (received → completed, process.edn auto-complete): after a step lands an
 * order here, the page reads it again until it has moved on.
 */
export const PASSING_STATES = [S.RECEIVED];

/**
 * Not a transition: the seller puts what a refunded return brought back in
 * stock again (server/api/order-relist.js). Shown and handled like a step.
 */
export const RELIST = 'custom/relist';
